"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.innerXML = exports.outerXML = exports.wrapXML = void 0;
const xmlReplacers = {
    "<": "&lt;",
    ">": "&gt;",
    "&": "&amp;",
    "\"": "&quot;",
    "'": "&apos;",
};
const wrapXML = (el, inner) => {
    const attr = Object.keys(el.attr)
        .map(key => ` ${key}="${el.attr[key]?.replace(/[<>&"']/g, c => xmlReplacers[c]) ?? ""}"`)
        .join("");
    if (inner) {
        return `<${el.tag}${attr}>${inner}</${el.tag}>`;
    }
    else {
        return `<${el.tag}${attr}/>`;
    }
};
exports.wrapXML = wrapXML;
const outerXML = (el, withControlEl = false) => {
    const inner = (0, exports.innerXML)(el, withControlEl);
    if (withControlEl || el.tag[0] !== "_") {
        return (0, exports.wrapXML)(el, inner);
    }
    else {
        return inner;
    }
};
exports.outerXML = outerXML;
const innerXML = (el, withControlEl = false) => {
    if (!el.children)
        console.error(el);
    return el.children.map(child => (typeof child === "string")
        ? child.replace(/[<>&"']/g, c => xmlReplacers[c])
        : (0, exports.outerXML)(child, withControlEl)).join("");
};
exports.innerXML = innerXML;
//# sourceMappingURL=elToXML.js.map